/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentactivity_Subscriptionrenewed2Inputs */

const he_dashboard_recentactivity_subscriptionrenewed2 = /** @type {(inputs: Dashboard_Recentactivity_Subscriptionrenewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מנוי חודש`)
};

const en_dashboard_recentactivity_subscriptionrenewed2 = /** @type {(inputs: Dashboard_Recentactivity_Subscriptionrenewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscription renewed`)
};

/**
* | output |
* | --- |
* | "Subscription renewed" |
*
* @param {Dashboard_Recentactivity_Subscriptionrenewed2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_subscriptionrenewed2 = /** @type {((inputs?: Dashboard_Recentactivity_Subscriptionrenewed2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Subscriptionrenewed2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_subscriptionrenewed2(inputs)
	return en_dashboard_recentactivity_subscriptionrenewed2(inputs)
});
export { dashboard_recentactivity_subscriptionrenewed2 as "dashboard_recentActivity_subscriptionRenewed" }